import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../services/api-service";

import { addLookup } from "./lookupSlice";
import { closeClientModal } from "./modalSlice";
import { success } from "./notificationSlice";
import { updatePage } from "./surveySlice";

const initialState = {
  client: { name: "" },
  allClients: [],
};

export const getClients = createAsyncThunk(
  "getClients",
  async (
    { pageNum, searchText, pageSize },
    { rejectWithValue, dispatch, getState }
  ) => {
    try {
      const response = await api.get(
        `get-clients?pageNumber=${pageNum}&searchText=${searchText}&pageSize=${
          pageSize ? pageSize : getState().survey.pageSize
        }`
      );
      if (response?.ok) {
        dispatch(updatePage(pageNum));
        dispatch(addLookup({ type: "client", value: response.data.data.data }));
        return { ...response };
      } else throw new Error({ ...response });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createClient = createAsyncThunk(
  "addClient",
  async (client, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post("add-client", client);
      if (response && response.ok) {
        dispatch(getClients({ pageNum: 1, searchText: "" }));
        dispatch(success({ message: "Client added successfully" }));
        dispatch(closeClientModal());
        return { ...response };
      } else {
        throw new Error({ ...response });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateClient = createAsyncThunk(
  "updateClient",
  async (client, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.put(`update-client/${client.id}`, client);
      if (response && response.ok) {
        dispatch(success({ message: "Client updated successfully" }));
        dispatch(getClients({ pageNum: 1, searchText: "" }));
        dispatch(closeClientModal());
        return { ...response };
      } else {
        throw new Error({ ...response });
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    setClientField: (state, action) => {
      state.client[action.payload.field] = action.payload.value;
    },
    setClient: (state, action) => {
      state.client = action.payload;
    },
    resetClient: (state) => {
      state.client = initialState;
    },
  },
  extraReducers: (builders) => {
    builders
      .addCase(getClients.fulfilled, (state, actions) => {
        state.allClients = actions.payload.data?.data;
      })
      .addCase(updateClient.fulfilled, (state, actions) => {
        state.client = initialState;
      });
  },
});

// Action creators are generated for each case reducer function
export const { setClientField, setClient, resetClient } = clientSlice.actions;
export const clientSelector = (state) => state.client;
export const allClients = (state) => state.allClients;

export default clientSlice.reducer;
